import { render } from "./addGoods.vue?vue&type=template&id=227a8335&scoped=true"
import script from "./addGoods.vue?vue&type=script&lang=js"
export * from "./addGoods.vue?vue&type=script&lang=js"

import "./addGoods.vue?vue&type=style&index=0&id=227a8335&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227a8335"]])

export default __exports__